<template>
  <FormSection :title="$t('ACCOUNT.STATUS.RECEIPTS')">
    <div class="small-12 columns">
      <CardApiError
        v-if="apiError"
        :error-text="$t('ACCOUNT.STATUS.API_ERROR')"
        @retry="getReceipts"
      />
      <Card v-else :is-loading="isLoading" no-padding>
        <TableReceipts :receipts="receipts" />
      </Card>
    </div>
  </FormSection>
</template>

<script>
import CardApiError from '@@/common/CardApiError';
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import TableReceipts from './ReceiptsTable';

import { Membership } from '@/api/api';

export default {
  name: 'AccountReceipts',
  components: {
    CardApiError,
    FormSection,
    Card,
    TableReceipts,
  },
  data() {
    return {
      apiError: false,
      isLoading: true,
      receipts: [],
    };
  },
  created() {
    this.getReceipts();
  },
  methods: {
    getReceipts() {
      this.apiError = false;
      this.isLoading = true;

      return Membership.getReceipts()
        .then(({ body: { membership_receipts: receipts } }) => {
          this.receipts = [...receipts];
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }

          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
